import create from 'zustand'
import { QrDataInputLyl, UtilizedOfferOutputLyl } from '../graphql'

interface VerifyStore {
  rawQrCode: string | undefined
  parsedQrCode: QrDataInputLyl | undefined
  error: string | undefined
  offer: UtilizedOfferOutputLyl | undefined
  offers: UtilizedOfferOutputLyl[] | undefined
  setRawQrCode: (nextRawQrCode: string | undefined) => void
  setParsedQrCode: (nextParsedQrCode: QrDataInputLyl | undefined) => void
  setError: (nextError: string | undefined) => void
  setOffer: (nextOffer: UtilizedOfferOutputLyl | undefined) => void
  setOffers: (nextOffers: UtilizedOfferOutputLyl[] | undefined) => void
  reset: () => void
}

export const useVerifyStore = create<VerifyStore>((set) => ({
  rawQrCode: undefined,
  parsedQrCode: undefined,
  error: undefined,
  offer: undefined,
  offers: undefined,
  setRawQrCode: (nextRawQrCode: string | undefined) => {
    set(() => ({ rawQrCode: nextRawQrCode }))
  },
  setParsedQrCode: (nextParsedQrCode: QrDataInputLyl | undefined) => {
    set(() => ({ parsedQrCode: nextParsedQrCode }))
  },
  setError: (nextError: string | undefined) => {
    set(() => ({ error: nextError }))
  },
  setOffer: (nextOffer: UtilizedOfferOutputLyl | undefined) => {
    set(() => ({ offer: nextOffer }))
  },
  setOffers: (nextOffers: UtilizedOfferOutputLyl[] | undefined) => {
    set(() => ({ offers: nextOffers }))
  },
  reset: () => {
    set(() => ({
      rawQrCode: undefined,
      parsedQrCode: undefined,
      error: undefined,
      offer: undefined,
      offers: undefined,
    }))
  },
}))
